export const TOGGLE_SIDEBAR_STATE = 'TOGGLE_SIDEBAR_STATE'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const TOGGLE_TREE_ITEM = 'TOGGLE_TREE_ITEM'

